import React from "react";
import { useGetAssignmentsMarkQuery } from "../../../features/assignmentMark/assignmentMarkApi";

export default function AssignmentStatus() {
  const { data: assignmentsMark } = useGetAssignmentsMarkQuery() || {};

  let Total = 0;
  let Pending = 0;
  let Sent = 0;

  assignmentsMark?.forEach((assignment) => {
    Total = Total + 1;
    if (assignment.status === "pending") {
      Pending = Pending + 1;
    } else if (assignment.status === "published") {
      Sent = Sent + 1;
    }
  });

  return (
    <ul className="assignment-status">
      <li>
        Total <span>{Total}</span>
      </li>
      <li>
        Pending <span>{Pending}</span>
      </li>
      <li>
        Mark Sent <span>{Sent}</span>
      </li>
    </ul>
  );
}
